/**
 * @generated SignedSource<<3fd993f0189405c8e81fd04f761fea67>>
 * @relayHash 78786cdf5d9bb8e96a1e77d766d70147
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 78786cdf5d9bb8e96a1e77d766d70147

import { ConcreteRequest } from 'relay-runtime';
export type Ch_sendDataGuardPatientConsentInput = {
  patientId: string;
};
export type useChSendDataGuardPatientConsentMutation$variables = {
  input: Ch_sendDataGuardPatientConsentInput;
};
export type useChSendDataGuardPatientConsentMutation$data = {
  readonly ch_sendDataGuardPatientConsent: {
    readonly boolean: boolean | null;
  };
};
export type useChSendDataGuardPatientConsentMutation = {
  response: useChSendDataGuardPatientConsentMutation$data;
  variables: useChSendDataGuardPatientConsentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Ch_sendDataGuardPatientConsentPayload",
    "kind": "LinkedField",
    "name": "ch_sendDataGuardPatientConsent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChSendDataGuardPatientConsentMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChSendDataGuardPatientConsentMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "78786cdf5d9bb8e96a1e77d766d70147",
    "metadata": {},
    "name": "useChSendDataGuardPatientConsentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "70721cb5daddd00e2fac67ac00219946";

export default node;
